import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const HotGalvanizedWire = () => {
  const singleProductData = productData.filter((val) => val.id === 8);
  return (
    <>
      <Helmet>
        <title>
          Heavy Duty Metal Fence Panels | Hot-Dipped Galvanized Steel Panels
        </title>
        <meta
          name="description"
          content="We manufacture heavy duty steel fence panels that are hot-dipped, galvanized, and can withstand the elements for a long time."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default HotGalvanizedWire;
